import { createViewInstance, registerView } from './views';

export default function init_render(IconsView, iconsViewCache) {

    IconsView.registerView = registerView;

    IconsView.prototype.getTypes = function (data) {
        let currentType = (data && data.type) ? data.type : 'item';
        if (typeof currentType === 'string') currentType = [currentType];
        return currentType;
    };

    IconsView.prototype.getActiveView = function () {
        if (!this.activeViewInstance || this.activeViewInstance.name !== this.view) {
            if (this.activeViewInstance && typeof this.activeViewInstance.destroy === 'function') {
                try {
                    this.activeViewInstance.destroy();
                } catch (e) {}
            }
            this.activeViewInstance = createViewInstance(this.view, this);
        }
        return this.activeViewInstance;
    };

IconsView.prototype.render = function (node) {
        const myself = this;

        this.containerView = $('<div class="iv__view"></div>');

        this.scrollLast = $(window).scrollTop();

        // Buttons bar
        let formData = getFormData(this.element);
        myself.onUnload(this.element);
        this.element.html('');
        this.element.append(this.containerView);
        if (this.isCensored) {
            this.element.addClass('iv--censored');
            this.containerView.addClass('iv--censored');
        }
        if (this.template && this.template.toolbar) {
            myself.renderToolbar(this.template.toolbar, this.element, 'iv__toolbar ' + myself.clsBarTop, false, formData);
        }
        this.element.data('plugin', this);

        // Buttons bar
        if (this.template && this.template.buttons) {
            myself.renderToolbar(this.template.buttons, this.element, 'iv__toolbar ' + myself.clsBarBot, true, formData);
        }

        // autofix empty path
        if (!Array.isArray(this.path)) this.path = [];

        // breadcrumb
        myself.renderBreadcrumb();

        // Defined group Tab mode
        const hasDefinedTabs = (this.options.features.tab && typeof this.options.features.tab === 'object') || (this.template && this.template.tab && typeof this.template.tab === 'object');
        if (hasDefinedTabs) {
            this.tabMode = 'defined';

            let dataNode;
            if (node) {
                dataNode = node;
            } else if (!this.dataNode) {
                dataNode = this.data;
            } else {
                dataNode = this.dataNode;
            }

            // Find missing groups
            const detectedGroups = {};
            $.each(dataNode, (index, item) => {
                detectedGroups[item.group] = 1;
            });


            // Gather all defined tabs (from options and template)
            const definedTabs = [];
            const seenIds = new Set();
            if (this.options.features.tab && typeof this.options.features.tab === 'object') {
                $.each(this.options.features.tab, (index, iconData) => {
                    if (iconData) {
                        definedTabs.push({ iconData, isFromTemplate: false });
                        if (iconData.id) seenIds.add(iconData.id);
                    }
                });
            }
            if (this.template && this.template.tab && typeof this.template.tab === 'object') {
                $.each(this.template.tab, (index, iconData) => {
                    if (iconData) {
                        // Avoid duplicates if the same tab ID is already defined in options
                        if (!iconData.id || !seenIds.has(iconData.id)) {
                            definedTabs.push({ iconData, isFromTemplate: true });
                            if (iconData.id) seenIds.add(iconData.id);
                        }
                    }
                });
            }

            // Loop for each tabs group
            $.each(definedTabs, (index, tabInfo) => {
                const iconData = tabInfo.iconData;
                if (iconData) {
                    detectedGroups[iconData.id] = 0;

                    const filteredNode = [];
                    $.each(dataNode, (index, item) => {
                        if (item.group == iconData.id || !item.group) {
                            filteredNode.push(item);
                        }
                    });

                    /*
                    if (filteredNode.length < 1 || (filteredNode.length == 1 && filteredNode[0].special)) {
                        tabHeader.hide();
                    } else {
                        tabsHeader.append(tabHeader);
                        tabsContainer.append(tabContain);
                        tabHeader.show();
                    }
                     */

                    myself.addTab(iconData, filteredNode, tabInfo.isFromTemplate);
                }
            });

            // Orphan groups
            $.each(detectedGroups, (index, iconData) => {
                if (iconData) {
                    iconData = {
                        id: index,
                        label: index,
                        icon: '',
                    };

                    const filteredNode = [];
                    $.each(dataNode, (index, item) => {
                        if (item.group == iconData.id || !item.group) {
                            filteredNode.push(item);
                        }
                    });

                    myself.addTab(iconData, filteredNode, false);
                }
            });

            myself.reloadInput = true;

            // droppable Tabs
            var tabsContainer = this.containerView.find('.iv__tabs');
            myself.renderDroppable(tabsContainer);

            // Rollback for notabs
            if (!tabsContainer.find('.iv__tabs__pane').length) {
                this.tabMode = null;
                this.renderFrame(node);
            }
        }
        // First item Tab mode
        else if (this.options.features.tab && this.path.length == 0) {
            this.tabMode = 'first';
            if (node) {
                this.dataNode = node;
            } else {
                this.dataNode = node = this.data;
            }

            this.element.data('plugin', this);

            // Loop for each icons
            $.each(node, (index, iconData) => {
                if (iconData) {
                    myself.addTab(iconData, iconData.childs);
                }
            });

            myself.reloadInput = true;

            // droppable Tabs
            var tabsContainer = this.containerView.find('.iv__tabs');
            myself.renderDroppable(tabsContainer);
        }
        // normal mode
        else {
            this.tabMode = null;
            this.renderFrame(node);
        }

        // input refresh
        if (myself.reloadInput) {
            if (myself.events.refreshInput) myself.events.refreshInput(myself.element);
        }

        // scroll
        myself.scroll();

        if (!myself.dataNodeParent.iconSize) myself.dataNodeParent.iconSize = {};
        const currentIconSize = myself.dataNodeParent.iconSize[myself.view];

        myself.setIconSize((currentIconSize) || myself.viewThumbsHeight);

        myself.changeSelection();

        // event
        if (myself.events.render) myself.events.render(myself.element);
        myself.element.trigger('iv:render', [myself]);
        myself.element.trigger('iconsview:render', [myself]);
    };


IconsView.prototype.addTab = function (iconData, filteredNode, isFromTemplate) {
        const myself = this;
        if (!this.containerView.find('.iv__tabs').length) {
            const instanceUid = myself.name || myself.element.attr('id') || parseInt(Math.random() * 1000000);
            var tabsContainer = $('<div class="iv__tabs tabs" name="tabs-iconview-' + instanceUid + '" id="tabs-iconview-' + instanceUid + '"></div>');
            var tabsHeaderWrap = $('<div class="iv__tabs__nav__wrap tabs__nav__wrap"><ul class="tabs__nav iv__tabs__nav" id="tab-iconview-btns-' + instanceUid + '"></ul></div>');
            var tabsHeader = tabsHeaderWrap.find('.iv__tabs__nav');

            tabsContainer.append(tabsHeaderWrap);
            this.containerView.append(tabsContainer);

            tabsContainer.on('tabsactivate', (event, ui) => {
                myself.fixedTab[myself.templateName] = ui.newTab.data('id');

                const tabContain = $(ui.newPanel);
                if (tabContain.data('rendered') === false) {
                    myself.renderFrame(tabContain.data('node'), tabContain, false);
                    if (myself.events.render) myself.events.render(tabContain);
                }

                myself.setIconSize(myself.viewThumbsHeight, tabContain);
            });
        } else {
            var tabsContainer = this.containerView.find('.iv__tabs');
            var tabsHeader = this.containerView.find('.iv__tabs__nav');
        }

        // Loop for each icons
        if (iconData.special == 'root' || iconData.special == 'parent') return true;
        const data = iconData;
        let currentIconReact;
        let currentIcon;
        let currentType = (iconData.type) ? iconData.type : 'item';
        if (typeof currentType == 'string') currentType = [currentType];
        let currentClass = (iconData.class) ? iconData.class : [];
        if (typeof currentClass === 'object') currentClass = currentClass.join(' ');
        const currentRandomId = parseInt(Math.random() * 1000000000);
        const currentClassAll = [
            'iv__tabs__btn',
            'tabs__btn',
            'tab-btn',
            'iv__item iv__item--' + data.id,
            'iv__item--' + data.id + '--' + currentRandomId,
            currentClass
        ];
        $.each(currentType, function() {
            currentClassAll.push('iv__item--type-' + this);
        })
        if (iconData.ref) currentClassAll.push('iv__item--ref-' + iconData.ref);
        let tabName = formatFilename(data.label);
        if (!tabName) tabName = formatFilename(data.icon);
        var currentTabNb = tabsContainer.children().length-1;
        var isActive = (myself.fixedTab[myself.templateName] == data.id)?true:false;
        if (isActive) {
            currentClassAll.push('ui-tabs-active ui-state-active');
            tabsContainer.attr('value', currentTabNb);
        }

        const instanceUid = myself.name || myself.element.attr('id') || parseInt(Math.random() * 1000000);
        const scopedTabId = 'tab-' + instanceUid + '-' + tabName;
        const tabHeader = $(`
        <li id="btn-${scopedTabId}" data-id="${data.id}" class="tabs__btn tab-pointage-tab ui-state-default ui-tab ui-tabs-tab ${currentClassAll.join(' ')}"
            role="tab"
            aria-controls="${scopedTabId}"
            aria-selected="${data.active ? 'true' : 'false'}"
            aria-expanded="${data.active ? 'true' : 'false'}"
            aria-labelledby="ui-id-${data.uiId || scopedTabId}">
            <a href="#${scopedTabId}" class="tabs__link ui-tabs-anchor" draggable="false" tabindex="-1" id="ui-id-${data.uiId || scopedTabId}">
                <span class="tabs__ico icon ico" data-ico="${data.icon}">
                    <span class="ico" data-size="32" data-ico="${data.icon}" style="width: 32px; height: 32px;">
                        ${myself.renderIconImage('small', data.icon, data)}
                    </span>
                </span>
                ${data.label ? `<span class="tabs__label label">${data.label}</span>` : ''}
            </a>
        </li>
        `);
        const tabContain = $('<div class="iv__tabs__pane tabs__pane tabs__pane--stick tab-content tab-' + tabName + '" id="' + scopedTabId + '"></div>');
        tabContain.data('item', tabHeader);

        tabHeader.data('type', currentType);
        tabHeader.data('plugin', myself);
        tabHeader.data('data', data);

        let hideTab = false;
        if (!isFromTemplate) {
            if (filteredNode.length < 1 || (filteredNode.length == 1 && filteredNode[0].special && this.options.features.tab !== true)) {
                hideTab = true;
            }
        }
        if (hideTab) {
            tabHeader.hide();
        } else {
            tabsHeader.append(tabHeader);
            tabsContainer.append(tabContain);
            tabHeader.show();
        }

        const hasTemplateTab = (this.template && this.template.tab && typeof this.template.tab === 'object');
        if (tabsHeader.children().length > 1 || this.options.features.tab === true || hasTemplateTab) tabsHeader.show();
        else tabsHeader.hide();

        tabContain.data('node', filteredNode);
        if (tabsHeader.children().length < 2 || isActive) {
            myself.renderFrame(filteredNode, tabContain, false);
        } else {
            tabContain.data('rendered', false);
        }
    }


IconsView.prototype.renderDroppable = function (element) {
        const myself = this;
        // Enable drop on Containers
        if (this.options.features.droppable) {
            this.element.addClass('iv--feature-droppable');
            $.each(this.options.features.droppable, function (indexDrop, columnDrop) {
                const target = [];
                let accept = [];
                const dropProperties = this;

                for (var i = 0; i < this.target.length; i++) {
                    var currentEl = this.target[i];
                    if (currentEl == 'ref') currentEl = 'REF';
                    else currentEl = '.iv__item--type-' + currentEl;
                    target.push(currentEl);
                }

                if (this.accept instanceof Array) {
                    for (var i = 0; i < this.accept.length; i++) {
                        var currentEl = this.accept[i];
                        if (currentEl == 'ref') currentEl = 'REF';
                        else currentEl = '.iv__item--type-' + currentEl;
                        accept.push(currentEl);
                    }
                } else {
                    for (var currentEl in this.accept) {
                        if (currentEl == 'ref') currentEl = 'REF';
                        else currentEl = '.iv__item--type-' + currentEl;
                        if (currentEl) accept.push(currentEl);
                    }
                }
                const dropableTarget = element.closest('.iv').find(target.join(', '));
                $.each(this.accept, (acceptIndex, acceptName) => {
                    if (acceptName instanceof Object) acceptName = acceptIndex
                    dropableTarget.data('droppable-' + acceptName, clone(dropProperties));
                });

                let dropableTargetElement = dropableTarget.find('.iv__item__image');
                if (myself.view == 'tree' || myself.view == 'blocks') {
                    dropableTargetElement = dropableTarget.filter('.iv__tabs__btn').find('.iv__item__image');
                }

                dropableTargetElement.each(function() {
                    let acceptInst = accept;
                    let similarRefIndex = acceptInst.indexOf('REF')
                    if (similarRefIndex !== -1) {
                        let similarRef = $(this).closest('.iv__item').attr('class').match(/iv__item--ref-(\d+)/);
                        if (similarRef && similarRef.length > 1) {
                            acceptInst = clone(accept);
                            acceptInst[similarRefIndex] = '.iv__item--ref-'+similarRef[1];
                        }
                    }

                    $(this).droppable({
                        accept: acceptInst.join(', '),
                        tolerance: 'pointer',
                        dropProperties,
                        over(event, ui) {
                            $(event.target.closest('.iv__item')).addClass('iv__item--target');
                            $('.iv__drag').addClass('iv__drag--target');
                            var dragImg = $('.iv__drag .iv__item__image');
                            var dragImgDest = $(event.target).closest('.iv__item').find('.iv__item__image');
                            dragImg.data('originalWidth', dragImg.width()).data('originalHeight', dragImg.height())
                            dragImg.css('position', 'fixed').css('left', dragImgDest.offset().left).css('top', dragImgDest.offset().top - $(document).scrollTop()).css('width', dragImgDest.width()+'px').css('height', dragImgDest.height()+'px');
                            $(event.target.closest('.iv')).addClass('hide-sortable');
                            myself.setCursor('drop');
                        },
                        out(event, ui) {
                            $('.iv__item--target').removeClass('iv__item--target');
                            $('.iv__drag').removeClass('iv__drag--target');
                            var dragImg = $('.iv__drag .iv__item__image');
                            dragImg.css('position', 'relative').css('left', 0).css('top', 0).css('width', dragImg.data('originalWidth')+'px', dragImg.data('originalHeight')+'px')
                            $('.hide-sortable').removeClass('hide-sortable');
                            myself.setCursor('last');
                        },
                        drop(e, ui) {
                            const grid = $(this).closest('.iconGrid');

                            // basics manipulations
                            $('.iv__item--target').removeClass('iv__item--target');
                            $('.hide-sortable').removeClass('hide-sortable');
                            const myself = $(this).closest('.iv__item').data('plugin');
                            const dropped = ui.draggable;
                            let droppedItems = [dropped];
                            let target = $(this).closest('.iv__item');

                            if (!target || !target.length) {
                                target = $(this).find('.iv__item--special-parent');
                            }

                            // find
                            let dropProperties = target.data('droppable-' + $(dropped).data('type'));
                            if (!dropProperties && $(dropped).data('ref') == $(target).data('ref') && target.data('droppable-ref')) dropProperties = target.data('droppable-ref');

                            // selected
                            if (grid.find('.iv__item--selected').length > 0) {
                                droppedItems = grid.find('.iv__item--selected');
                            }

                            // submit
                            myself.submitParent(droppedItems, target, dropProperties);
                        },
                    });
                });
            })
        } else {
            this.element.removeClass('iv--feature-droppable');
        }
    }


IconsView.prototype.renderBreadcrumb = function () {
        const myself = this;
        const { element } = this;

        if (!Array.isArray(this.path)) this.path = [];

        // fil d'Ariane
        if (this.options.features.breadcrumb == true || (this.options.features.breadcrumb == 'auto' && this.path && this.path.length > 0)) {
            const filAriane = $('<div class="iv__breadcrumb grid-fil-ariane"></div>');
            let count = 0;
            for (let i = 0; i <= this.path.length; i++) {
                const filArianeNodePath = this.path.slice(0, i);
                const filArianeCurrent = myself.loadPath(filArianeNodePath);
                let filArianeType = (filArianeCurrent && filArianeCurrent.type) ? filArianeCurrent.type : 'unknown';
                if (i == 0 && myself.rootType && filArianeCurrent) {
                    filArianeType = myself.rootType;
                    filArianeCurrent.id = myself.rootId;
                }
                if (typeof filArianeType == 'string') filArianeType = [filArianeType];
                const currentClassAll = [
                    'iv__breadcrumb__item',
                    'iv__item',
                    'path-node',
                ];
                $.each(filArianeType, function() {
                    currentClassAll.push('iv__item--type-' + this);
                });
                if (filArianeCurrent && filArianeCurrent.ref) currentClassAll.push('iv__item--ref-' + filArianeCurrent.ref);
                const iconCode = (filArianeCurrent && filArianeCurrent.icon) ? filArianeCurrent.icon : 'place-home';
                const labelText = (filArianeCurrent && filArianeCurrent.label) ? filArianeCurrent.label : '';
                const filArianeNode = $('<span class="' + currentClassAll.join(' ') + '">'
                    + ((i > 0)
                        ? '<div class="iv__item__image iv__breadcrumb__item__image">' + myself.renderIconImage('small', iconCode) + '</div>'
                            + '<div class="iv__breadcrumb__item__label">' + labelText + '</div>'
                        : '<div class="iv__item__image iv__breadcrumb__item__image">' + myself.renderIconImage('small', 'place-home') + '</div>'
                            + '<div class="iv__breadcrumb__item__label"></div>'
                    )
                    + '</span>');
                if (filArianeCurrent) {
                    filArianeNode.data('id', filArianeCurrent.id);
                    filArianeNode.data('type', filArianeType);
                    filArianeNode.data('data', filArianeCurrent);
                }
                filArianeNode.data('plugin', myself);
                if (i == 0 || (filArianeCurrent && filArianeCurrent.label)) {
                    filArianeNode.data('path', filArianeNodePath);
                    if (i > 0) filAriane.append('<span class="iv__breadcrumb__separator"></span>');
                    filAriane.append(filArianeNode);
                }
                count++;
            }
            element.prepend(filAriane);
            filAriane.find('.path-node').click(function () {
                const button = $(this);
                const grid = $(button).closest('.iconGrid');
                const myself = grid.data('plugin');
                myself.setPath($(this).data('path'), true);
                myself.loadPath(null, true);
                myself.render();
            });
        }
    }


IconsView.prototype.renderFrame = function (node, element, subdir) {
        const myself = this;
        let columnData = '';

        if (myself.options.event.backup) {
            myself.options.event = myself.options.event.backup;
        }

        if (!subdir) {
            if (node) {
                myself.dataNode = node;
            } else if (!myself.dataNode) {
                myself.dataNode = myself.data;
            }
            node = myself.dataNode;
        }

        if (!element) element = myself.containerView;

        // prepare container
        myself.items = [];
        element.data('rendered', true);
        element.data('plugin', myself);

        // generic menu context
        myself.buildGlobalMenu();

        // VIEW container
        myself.preview = null;
        const activeView = myself.getActiveView();
        activeView.createContainer(element);
        activeView.postCreateContainer(element, node, subdir);


        // Loop for each icons
        if (node) {
            myself.renderIconsArea(node, element.find('.view'), subdir, myself.path);
        } else if (myself.data.message) {
            myself.onUnload(element);
            element.html('<div class="message ' + myself.data.status + '">' + myself.data.message + '</div>');
        }
        // myself.restoreFilter();

        if (myself.element.find('.iv__container--tmp').length) {
            element.append(myself.element.find('.iv__container--tmp').children()[0]);
            myself.element.find('.iv__container--tmp').hide();
        }


        // Enable drag & drop upload
        if (myself.template && myself.template.upload) {
            element.append(`<div class="iv__upload"><div class="iv__upload__progress iv__upload__progress--global progress b-progress"><div class="iv__upload__progress__bar bar"></div></div><div class="iv__upload__files js-files b-upload__files">
                <div class="js-file-tpl iv__upload__thumb b-thumb" data-id="<%=uid%>" title="<%-name%>, <%-sizeText%>">
                <div class="iv__upload__preview">
                <div class="iv__upload__preview__pic"></div>
                </div>
                <div class="iv__upload__progress progress progress-small"><div class="iv__upload__progress__bar bar"></div></div>
                <div class="iv__upload__name"></div>
                </div>
                </div><div class="iv__upload__message"><div class="iv__upload__title">transfert de fichier</div><div class="iv__upload__nb">1 / 1</div></div></div>`);

            let uploadData = {};
            uploadData[(myself.template.upload.parent) ? myself.template.upload.parent : 'parent'] = (myself.dataNodeParent && myself.dataNodeParent.id) ? myself.dataNodeParent.id : myself.rootId;

            myself.element.find('.iv__upload').slideUp().addClass('iv__upload--hidden');
            myself.element.fileapi({
                url: myself.template.upload.request,
                paramName: (myself.template.upload.field) ? myself.template.upload.field : 'filedata',
                // accept: 'image/*',
                data: uploadData,
                autoUpload: (!myself.template.upload.crop),
                transform: false,
                elements: {
                    list: '.iv__upload__files',
                    progress: '.iv__upload .iv__upload__progress .iv__upload__progress__bar',
                    file: {
                        tpl: '.iv__upload__thumb',
                        preview: {
                            el: '.iv__upload__preview',
                            width: 256,
                            height: 180,
                        },
                        upload: { show: '.iv__upload__progress' },
                        complete: { hide: '.iv__upload__progress' },
                        progress: '.iv__upload__progress .iv__upload__progress__bar',
                    },
                    dnd: {
                        el: '.iv__container',
                        hover: 'iv__container--active',
                        fallback: '.iv__upload__dnd-not-supported',
                    },
                },
                onFileComplete(evt, ui) {
                    if (ui.error) {
                        msg('error', 'Impossible de téléverser le fichier : le fichier est introuvable ou inaccessible.');
                    }
                },
                onComplete(evt, ui) {
                    myself.element.find('.iv__upload').slideUp().addClass('iv__upload--hidden');
                    myself.load();
                    myself.isBusy = false;
                },
                onDrop(evt, ui) {
                    if ((ui.other && ui.other.length) || (ui.files && ui.files.some(f => f.error || f.errors))) {
                        msg('error', 'Impossible d\'importer le fichier : le fichier n\'existe plus ou est inaccessible sur votre ordinateur.');
                    }
                    if (ui.files.length && myself.template.upload.crop) {
                        myself.isBusy = true;
                        myself.element.find('.iv__upload').slideDown().removeClass('iv__upload--hidden');
                        const { files } = ui;
                        const cropOptionsGroups = myself.template.upload.crop;
                        const cropOptionsGroupsKey = Object.keys(cropOptionsGroups);
                        var cropWindow = function (index, subindex) {
                            const file = files[index];
                            const cropKey = cropOptionsGroupsKey[subindex];
                            const cropOptions = cropOptionsGroups[cropKey];
                            const cropableFormats = ['image/png', 'image/jpeg', 'image/gif', 'image/webp'];
                            console.log(file.type);

                            if (!cropableFormats.includes(file.type) || myself.template.upload.crop.length == 0) {
                                setTimeout(function() {
                                    // Boucler dans les images
                                    if (index < files.length - 1) {
                                        console.log('next image');
                                        cropWindow(index + 1, 0);
                                    }
                                    // Finir le processus
                                    else {
                                        console.log('end process');
                                        $(myself.element).fileapi('upload');
                                    }
                                }, 100)
                            }
                            else if (!FileAPI.support.transform) {
                                alert('Your browser does not support transform :(');
                            } else if (file) {
                                var currentWindow = $.window({
                                    id: 'imageBrowserWindow',
                                    title: 'Recadrage des images - ' + ((cropOptions.name)?cropOptions.name:cropKey) + ' (' + (index + 1) + ' de ' + files.length + ')',
                                    content: `<div id="popup-jcrop" class="popup-jcrop" style="display: none;">
                                        <div class="popup__body"><div class="js-img"></div></div>
                                        <div style="margin: 0 0 5px; text-align: center;">
                                        <div class="toolbar--form window__toolbar--bottom">
                                        <button class="btn-cancel btn-type-caution btn action--danger">Annuler</button>
                                        <button class="btn action--success action--submit js-upload btn_browse btn_browse_small">Valider</button>
                                        </div>
                                        </div>
                                        </div>`,
                                    maxWidth: -1, // the minimum width, if -1 means no checking
                                    maxHeight: -1,		 // the minimum height, if -1 means no checking
                                    showFooter: false,
                                    maximizable: false,
                                    closable: true,
                                    showModal: true,
                                    width: '98%',
                                    height: '98%',
                                    checkBoundary: true,
                                    withinBrowserWindow: false,
                                    onExit() {
                                        if (currentWindow.step != 'next') {
                                            myself.element.find('.iv__upload').slideUp().addClass('iv__upload--hidden');
                                        }
                                    },
                                    onShow() {
                                        const currentFrame = this.content;
                                        currentFrame.find('.js-upload').click(() => {
                                            currentWindow.step = 'next'
                                            currentWindow.close();
                                            // Boucler dans les variantes
                                            if (subindex < cropOptionsGroupsKey.length - 1) {
                                                console.log('next variation');
                                                cropWindow(index, subindex + 1);
                                            }
                                            else {
                                                // Boucler dans les images
                                                if (index < files.length - 1) {
                                                    console.log('next image');
                                                    cropWindow(index + 1, 0);
                                                }
                                                // Finir le processus
                                                else {
                                                    console.log('end process');
                                                    $(myself.element).fileapi('upload');
                                                }
                                            }
                                        });
                                        currentFrame.find('.btn-cancel').click(() => {
                                            if (index > 0) {
                                                Swal.fire({
                                                    title: 'Annuler l\'envoi des images ?',
                                                    text: 'Voulez-vous vraiment interompre l\'envoie des images ? Le découpage de toutes les images précédentes ne sera pas mémorisé et tous les transferts en cours seront annulé.',
                                                    type: 'warning',
                                                    showCancelButton: true,
                                                    confirmButtonColor: '#3085d6',
                                                    cancelButtonColor: '#d33',
                                                    confirmButtonText: 'Oui',
                                                    cancelButtonText: 'Non',
                                                }).then((result) => {
                                                    if (result.value) {
                                                        currentWindow.close();
                                                        $(myself.element).fileapi('clear');
                                                    }
                                                })
                                            } else {
                                                currentWindow.close();
                                                $(myself.element).fileapi('clear');
                                            }
                                        });
                                        $(currentFrame).find('.js-img').cropper({
                                            boxWidth: $(currentFrame).width(),
                                            boxHeight: $(currentFrame).height(),
                                            file,
                                            aspectRatio: (cropOptions.ratio) ? cropOptions.ratio : null,
                                            trueSize: true,
                                            setSelect: [0, 2000, 2000, 0],
                                            onSelect(coords) {
                                                if (myself.template.upload.crop.client) {
                                                    $(myself.element).fileapi('crop', file, coords);
                                                } else {
                                                    if (!file.data) file.data = {};
                                                    if (!file.data.crop) file.data.crop = {};
                                                    file.data.crop[cropKey] = {};
                                                    for (const key in coords) {
                                                        if (coords.hasOwnProperty(key)) {
                                                            file.data.crop[cropKey][key] = coords[key];
                                                            // $(myself.element).fileapi('data')[key] = coords[key];
                                                        }
                                                    }
                                                }
                                            },
                                        });
                                    },
                                });
                            }
                        }
                        cropWindow(0, 0);
                    }
                },
            });
        }
    };


IconsView.prototype.renderIconsAreas = function (node) {
        const myself = this;
        if (this.tabMode == 'first') {
            if (node) {
                this.dataNode = node;
            } else {
                this.dataNode = node = this.data;
            }

            // Loop for each icons
            $.each(node, (index, iconData) => {
                if (iconData) {
                    if (iconData.special == 'root' || iconData.special == 'parent') return true;
                    const data = iconData;
                    const tabName = formatFilename(data.label);
                    const tabContain = myself.element.find('.tab-' + tabName).find('> .iv__container');
                    if (tabContain.length) {
                        myself.renderIconsArea(data.childs, tabContain, false);
                    }
                }
            });

            myself.reloadInput = true;
        } else if (this.tabMode == 'defined') {
            if (node) {
                this.dataNode = node;
            } else {
                this.dataNode = node = this.data;
            }

            // Find missing groups
            const detectedGroups = {};
            $.each(this.dataNode, (index, item) => {
                detectedGroups[item.group] = 1;
            });

            const definedTabs = [];
            const seenIds = new Set();
            if (this.options.features.tab && typeof this.options.features.tab === 'object') {
                $.each(this.options.features.tab, (index, iconData) => {
                    if (iconData) {
                        definedTabs.push(iconData);
                        if (iconData.id) seenIds.add(iconData.id);
                    }
                });
            }
            if (this.template && this.template.tab && typeof this.template.tab === 'object') {
                $.each(this.template.tab, (index, iconData) => {
                    if (iconData) {
                        if (!iconData.id || !seenIds.has(iconData.id)) {
                            definedTabs.push(iconData);
                            if (iconData.id) seenIds.add(iconData.id);
                        }
                    }
                });
            }

            $.each(definedTabs, (index, iconData) => {
                if (iconData) {
                    detectedGroups[iconData.id] = 0;

                    const filteredNode = [];
                    $.each(node, (index, item) => {
                        if (item.group == iconData.id || !item.group) {
                            filteredNode.push(item);
                        }
                    });

                    const tabName = formatFilename(iconData.label) || formatFilename(iconData.icon);
                    let tabContain = myself.element.find('.tab-' + iconData.id).find('.iv__container');
                    if (!tabContain.length && tabName) {
                        tabContain = myself.element.find('.tab-' + tabName).find('.iv__container');
                    }
                    if (tabContain.length) {
                        myself.renderIconsArea(filteredNode, tabContain);
                    }
                }
            });
        } else {
            this.renderIconsArea(this.dataNode, myself.element.find('.view'));
        }
    }


IconsView.prototype.renderIconsArea = function (node, container, subdir, path) {
        const myself = this;

        if (!container.length) container = myself.container;
        container.find('.iv__item').remove();

        // Loop for each icons
        if (node) {
            this.renderIcons(node, container, subdir, path);

            myself.onUnload($('#sortHelper'));
            $('#sortHelper').html('');

            // Sortable behavior
            if (this.options.features.sortable && (myself.view == 'tree' || myself.view == 'blocks')) {
                this.element.addClass('iv--feature-sortable');
                container.nestedSortable({
                    forcePlaceholderSize: true,
                    listType: 'ol',
                    helper: 'clone',
                    items: '.iv__item:not(.iv__item--special-parent)',
                    toleranceElement: '> div',
                    opacity: 0.6,
                    placeholder: 'placeholder',
                    revert: 250,
                    tabSize: 25,
                    tolerance: 'pointer',
                    appendTo: '#sortHelper',
                    handle: '.iv__item__image',
                    isTree: true,
                    delay: 150,
                    distance: 5,
                    expandOnHover: 700,
                    startCollapsed: true,
                    handle: '.iv__item__preframe',
                    branchClass: 'iv__item--branch',
                    collapsedClass: 'iv__item--collapsed',
                    disableNestingClass: 'iv__item--nonesting',
                    errorClass: 'iv__item--error',
                    expandedClass: 'iv__item--expanded',
                    hoveringClass: 'iv__item--hovering',
                    leafClass: 'iv__item--leaf',
                    disabledClass: 'iv__item--disabled',
                    start(e, ui) {
                        const grid = $(this).closest('.iconGrid');

                        // Selection management: if dragging an unselected item, select only it
                        if (!ui.item.hasClass('iv__item--selected')) {
                            grid.find('.iv__item--selected').removeClass('iv__item--selected');
                            ui.item.addClass('iv__item--selected');
                            myself.selection = [];
                            myself.addSelectionFromIcon(ui.item);
                            myself.changeSelection(ui.item);
                        }

                        ui.placeholder.height(ui.item.height());
                        ui.placeholder.width(ui.item.width());
                    },
                    update(event, ui) {
                        const myself = $(this).closest('.iconGrid').data('plugin');
                        const grid = $(this).closest('.iconGrid');
                        const selectedItems = grid.find('.iv__item--selected');

                        // Move all selected items together in the DOM
                        const others = selectedItems.not(ui.item);
                        if (others.length > 0) {
                            ui.item.after(others);
                        }

                        myself.submitOrder();

                        // basics manipulations
                        const dropped = ui.item;
                        let target = ui.item.parent().closest('.iv__item');

                        // try with tab
                        if (!target.length) {
                            const currentTab = ui.item.parent().closest('.tab-content');
                            if (currentTab) {
                                target = currentTab.data('item');
                            }
                        }

                        if (!target || !target.length) {
                            target = $(this).find('.iv__item--special-parent');
                        }

                        // find
                        const dropProperties = target.data('droppable-' + $(dropped).data('type'));

                        // submit parent change for all selected items
                        myself.submitParent(selectedItems.toArray(), target, dropProperties);
                    },
                    stop(event, ui) {
                        const grid = $(this).closest('.iconGrid');
                        const selectedItems = grid.find('.iv__item--selected');

                        // Fix display block issue
                        ui.item.css('display', '');
                        selectedItems.css('display', '');
                    },
                    change() {
                    },
                    scrollSpeed: 8,
                    scroll: true,
                    cursorAt: { left: 58, top: -10 },
                });
            } else if (this.options.features.sortable) {
                this.element.addClass('iv--feature-sortable');
                container.sortable({
                    delay: 150,
                    items: '.iv__item:not(.iv__item--special-parent)',
                    create(event, ui) {
                    },
                    update(event, ui) {
                        const myself = $(this).closest('.iconGrid').data('plugin');
                        const grid = $(this).closest('.iconGrid');
                        const selectedItems = grid.find('.iv__item--selected');

                        // Move all selected items together in the DOM
                        const others = selectedItems.not(ui.item);
                        if (others.length > 0) {
                            ui.item.after(others);
                        }

                        myself.submitOrder();

                        // répliquer le changement d'ordre et de parent sur les nodes pour chaque item
                        selectedItems.each(function() {
                            const item = $(this);
                            const itemData = item.data('data');
                            let oldParent = item.data('parent');
                            if (oldParent && oldParent.childs) {
                                const index = oldParent.childs.findIndex(c => c.id === itemData.id && c.type === itemData.type);
                                if (index !== -1) oldParent.childs.splice(index, 1);
                                oldParent.childs.splice(item.index(), 0, itemData);
                            }
                        });
                    },
                    start(event, ui) {
                        const grid = $(this).closest('.iconGrid');

                        // Selection management: if dragging an unselected item, select only it
                        if (!ui.item.hasClass('iv__item--selected')) {
                            grid.find('.iv__item--selected').removeClass('iv__item--selected');
                            ui.item.addClass('iv__item--selected');
                            myself.selection = [];
                            myself.addSelectionFromIcon(ui.item);
                            myself.changeSelection(ui.item);
                        }

                        ui.placeholder.addClass('iv__placeholder');
                        ui.placeholder.height(ui.item.height());
                        ui.placeholder.width(ui.item.width());
                        ui.item.addClass('iv__item--moving');
                        grid.find('.iv__item--selected').not('.iv__placeholder').addClass('iv__item--moving');
                        myself.setCursor('sort');
                    },
                    stop(event, ui) {
                        const grid = $(this).closest('.iconGrid');
                        const selectedItems = grid.find('.iv__item--selected');

                        $(this).height('auto')
                        ui.item.removeClass('iv__item--moving');
                        grid.find('.iv__item--moving').removeClass('iv__item--moving');

                        // Fix display block issue
                        ui.item.css('display', '');
                        selectedItems.css('display', '');

                        myself.setCursor('');
                    },
                    helper: 'clone',
                    tolerance: 'intersect',
                    appendTo: '#sortHelper',
                    handle: '.iv__item__image',
                    distance: 5,
                    revert: 0,
                    scrollSpeed: 8,
                    scrollSensitivity: 20,
                    scroll: true,
                    cursorAt: { left: 58, top: -10 },
                });
            } else if (this.options.features.droppable) {
                this.element.removeClass('iv--feature-sortable');

                let draggableContainer = container.find('.iv__item').not('.iv__item--special-parent');

                /*
                draggableContainer.find('.iv__item__image').mousedown(function() {
                    let item = $(this).closest('.iv__item');
                    let ref = item.attr('class').match(/iv__item--ref-(\d+)/)[1];
                    myself.element.find('.iv__item--ref-match').removeClass('iv__item--ref-match');
                    if (ref) {
                        myself.element.find('.iv__item--ref-'+ref).addClass('iv__item--ref-match');
                    }
                });
                */

                draggableContainer.draggable({
                    delay: 150,
                    helper: 'clone',
                    appendTo: '#sortHelper',
                    handle: '.iv__item__image',
                    distance: 5,
                    scrollSpeed: 8,
                    scroll: true,
                    revert: 0,
                    revertDuration: 200,
                    cursorAt: { left: 58, top: -10 },
                    start(event, ui) {
                        const grid = $(this).closest('.iconGrid');
                        const item = $(this);

                        // Selection management
                        if (!item.hasClass('iv__item--selected')) {
                            grid.find('.iv__item--selected').removeClass('iv__item--selected');
                            item.addClass('iv__item--selected');
                            myself.selection = [];
                            myself.addSelectionFromIcon(item);
                            myself.changeSelection(item);
                        }

                        ui.helper.find('.iv__item__icon').css('background-image', 'url(' + ui.helper.find('.iv__item__icon').data('hd') + ')');
                        if (ui.item) ui.item.addClass('iv__item--moving');
                        else if (ui.helper.context) $(ui.helper.context).addClass('iv__item--moving');
                        grid.find('.iv__item--selected').not('.iv__placeholder').addClass('iv__item--moving');
                        myself.setCursor('sort');
                    },
                    stop(event, ui) {
                        const grid = $(this).closest('.iconGrid');
                        $(this).height('auto')
                        if (ui.item) ui.item.removeClass('iv__item--moving');
                        else if (ui.helper.context) $(ui.helper.context).removeClass('iv__item--moving');
                        grid.find('.iv__item--moving').removeClass('iv__item--moving');
                        myself.setCursor('drop');
                    },
                });
            } else {
                this.element.removeClass('iv--feature-sortable');
            }

            // Load data value
            container.find('.iv__item__input input, .iv__item__input select, .iv__item__input textarea').each(function (index) {
                const current = $(this).closest('.iv__item');
                const data = current.data('data');
                const inputContainer = $(this).closest('.iv__item__input');
                const currentValue = data.data[inputContainer.data('property')];
                if (currentValue) {
                    $(this).val(currentValue);
                }
            });
            // Enable input field modification
            container.find('.iv__item__input input, .iv__item__input select, .iv__item__input textarea').change(function () {
                const current = $(this).closest('.iv__item');
                const data = current.data('data');
                const inputContainer = $(this).closest('.iv__item__input');
                const request = {
                    id: data.id,
                }
                const property = inputContainer.data('property');
                request[property] = $(this).val();
                let compA = data.data[property];
                let compB = request[property];
                if (compA === '' || compA === undefined) compA = null;
                if (compB === '' || compB === undefined) compB = null;
                let propertyHasChanged = compA != compB;
                data.data[property] = $(this).val();

                if ($(this).attr('type') == 'checkbox' && !$(this).is(':checked')) {
                    request[property] = 0;
                    data.data[property] = 0;
                    propertyHasChanged = true;
                }

                if (propertyHasChanged) {
                    myself.submitChange(data, request);
                    if (myself.events.edit) myself.events.edit();
                }
            });

            // Enable EXPEND / Collapse feature
            container.find('.iv__item__expend').click(function (e) {
                const current = $(this).closest('.iv__item');
                if (current.hasClass('iv__item--expanded')) {
                    myself.treeExpend(current, false);

                    if (e.ctrlKey) {
                        var expendChilds = current.find('.iv__item');
                        expendChilds.each(function () {
                            myself.treeExpend($(this), false);
                        });
                    }
                } else {
                    myself.treeExpend(current, true);

                    if (e.ctrlKey) {
                        var expendChilds = current.find('.iv__item');
                        expendChilds.each(function () {
                            myself.treeExpend($(this), true);
                        });
                    }
                }
            });


            // click on iconGrid BG
            if (this.options.features.bgUnselect && !this.options.features.lockSelection) {
                container.click(function (event) {
                    if (!event.ctrlKey && !event.shiftKey) {
                        const grid = $(this).closest('.iconGrid');
                        grid.data('plugin').selection = [];
                        $(this).find('.iv__item').removeClass('iv__item--selected');
                        grid.data('plugin').changeSelection();
                    }
                }).children().click((e) => false);
            }

            // Final refresh
            myself.changeSelection();
            myself.sort();
            myself.renderDroppable(container);
        }

        if (!myself.dataNodeParent.loaded) {
            myself.lazyLoad(myself.dataNodeParent);
        }
    };


IconsView.prototype.treeExpend = function (current, status) {
        const myself = this;
        myself.dataExpand[current.data('type') + '-' + current.data('id')] = status;

        if (status) {
            current.find('> .iv__item__tree').slideDown(200);
            current.addClass('iv__item--expanded');
        } else {
            current.find('> .iv__item__tree').slideUp(200);
            current.removeClass('iv__item--expanded');
        }
    }


IconsView.prototype.renderIcons = function (node, container, subdir, path) {
        const myself = this;
        if (!container) container = myself.container;

        myself.element.addClass('iv--updated');

        $(container).addClass('iv__container');

        if (!path) path = [];

        // Loop for each icons
        let renderCount = 0;
        let pathChild;
        $.each(node, (index, iconData) => {
            pathChild = path.slice(0);
            pathChild.push(index - 1);

            if (myself.renderIcon(iconData, container, subdir, pathChild) && !iconData.special) {
                renderCount++;
            }
        });

        if (!renderCount && (!subdir || (myself.view != 'tree' && myself.view != 'blocks'))) {
            pathChild = path.slice(0);
            let emptySample = myself.options.sample.none;
            if (myself.template && myself.template.view && myself.template.view.empty) {
                const emptyConf = typeof myself.template.view.empty === 'string'
                    ? { label: myself.template.view.empty }
                    : myself.template.view.empty;
                emptySample = $.extend({}, myself.options.sample.none, emptyConf);
            }
            myself.renderIcon(emptySample, container, subdir, pathChild);
        }
        if (myself.view == 'tree' || myself.view == 'blocks') {
            container.addClass('iv__item__tree');
        }

        myself.resize();

        if (myself.updateTableBadgeColumnVisibility) {
            myself.updateTableBadgeColumnVisibility();
        }

        if (myself.updateToolbarCount) {
            myself.updateToolbarCount();
        }

        if (myself.updateCensorButton) {
            myself.updateCensorButton();
        }

        setTimeout(() => {
            myself.element.removeClass('iv--updated');
        }, 1000)

        return container.find('> .iv__item').length;
    };


IconsView.prototype.renderIcon = function (iconData, container, subdir, path) {
        const myself = this;

        if (iconData && myself.filter(iconData)) {
            // todo fix parent
            if (iconData.special == 'parent') {
                if (subdir || !this.path.length) {
                    return null;
                }
            }

            let data = iconData;
            data = this.remapData(data);
            if (!data.actions) data.actions = myself.options.actions;
            if (!data.default) data.default = myself.options.default;

            // Ensure count is resolved (si explicitement null, on ne calcule pas de count automatique)
            if (data.count === null) {
                // null explicite : ne rien faire, préserver null
            } else if (data.count === undefined || data.count === '') {
                const resolvedCount = myself.resolveItemCount(data);
                if (resolvedCount !== undefined) data.count = resolvedCount;
            } else if (typeof data.count !== 'number') {
                const parsedCount = parseInt(data.count, 10);
                data.count = isNaN(parsedCount) ? 0 : parsedCount;
            }

            const activeView = myself.getActiveView();
            const currentIcon = activeView.renderIcon(data, container, subdir, path);

            if (currentIcon) {
                if (myself.items !== undefined && !myself.items.includes(currentIcon)) {
                    myself.items.push(currentIcon);
                }
                return currentIcon;
            }
            return null;
        }
    };


IconsView.prototype.renderIconImage = function (size, icon, data, forceFill) {
        const iconDom = $('<div></div>');
        let fill = forceFill || '';
        if (size == 'thumb') fill = 'cover';
        else if (size == 'logo') fill = 'contain';
        if (!icon) {
            icon = [this.options.sample.default.icon];
            fill = 'contain';
        }

        const resolvedShape = typeof this.getItemShape === 'function'
            ? this.getItemShape(data, this.view)
            : ((data && (data.shape ?? (data.data && data.data.shape))) || 'default');

        if (resolvedShape === 'scare' || resolvedShape === 'square') {
            fill = 'cover';
        } else if (resolvedShape === 'circle') {
            fill = 'cover';
        } else if (resolvedShape === 'rectangle') {
            fill = 'contain';
        }

        iconDom.icons({
            size,
            data: icon,
            fill,
            shape: resolvedShape,
            mode: (forceFill === 'img' || forceFill === 'bg') ? forceFill : undefined,
        });
        return iconDom.html();
    }


/**
 * Render a structured subdata entry into an HTML span.
 *
 * Accepted formats for `rawVal`:
 *   - string                → plain text value
 *   - [text, icon, color]   → legacy array shorthand
 *   - {
 *       text   : string,   // displayed text (also accepted: 'value')
 *       icon   : mixed,    // icon descriptor passed to renderIconImage
 *       color  : string,   // CSS color applied as inline style
 *       style  : string,   // additional inline CSS (appended after color)
 *       class  : string,   // extra CSS class(es) on the wrapper span
 *     }
 */
IconsView.prototype.renderSubdata = function(rawVal, prefix, suffix, data) {
    if (!rawVal) return null;
    var itemValue, itemIcon, itemColor, itemStyle, itemClass, itemLabelClass;
    if (typeof rawVal === 'string') {
        itemValue = rawVal;
    } else if (Array.isArray(rawVal)) {
        itemValue = rawVal[0] || '';
        itemIcon  = rawVal[1] || '';
        itemColor = rawVal[2] || '';
    } else if (typeof rawVal === 'object' && rawVal !== null) {
        // Support both 'text' (new) and 'value' (legacy) keys
        itemValue      = rawVal.text  || rawVal.value || '';
        itemIcon       = rawVal.icon  || '';
        itemColor      = rawVal.color || '';
        itemStyle      = rawVal.style || '';
        itemClass      = rawVal.class || '';
        itemLabelClass = rawVal.labelClass || ''; // Support d'une classe custom pour le label
    }

    // Skip if value is empty
    if (!itemValue || (typeof itemValue === 'string' && itemValue.trim() === '')) {
        return null;
    }

    if (prefix) itemValue = prefix + (itemValue || '');
    if (suffix) itemValue = (itemValue || '') + suffix;

    // Enrobage du texte dans son propre span avec la classe dédiée
    var labelClass = 'iv__item__subdata__label' + (itemLabelClass ? ' ' + itemLabelClass : '');
    var labelHtml = '<span class="' + labelClass + '">' + itemValue + '</span>';

    // Build inline style
    var inlineStyle = '';
    if (itemColor) inlineStyle += 'color:' + itemColor + ';';
    if (itemStyle) inlineStyle += itemStyle;

    var wrapperClass = 'iv__item__subdata' + (itemClass ? ' ' + itemClass : '');

    var subdataHtml = '<span class="' + wrapperClass + '"'
        + (inlineStyle ? ' style="' + inlineStyle + '"' : '')
        + '>';

    if (itemIcon) {
        var $ico = $('<span class="iv__item__subdata__ico ico" data-size="32"></span>');
        var icoAttrVal = (typeof itemIcon === 'string') ? itemIcon : JSON.stringify(itemIcon);
        $ico.attr('data-ico', icoAttrVal);
        $ico.icons({ size: 32, data: itemIcon, fill: 'contain' });
        subdataHtml += $ico[0].outerHTML + ' ' + labelHtml;
    } else {
        subdataHtml += labelHtml;
    }

    subdataHtml += '</span>';
    return subdataHtml;
};

}
